"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SbInlineMessage = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactIntl = require("react-intl");

var _shapes = require("../../skybase-core/shapes");

var _locales = require("../../skybase-core/locales");

var _sbInlineMessageIcon = require("./sb-inline-message-icon");

var _constants = require("./constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var getClassNames = function getClassNames(type, className) {
  return (0, _classnames.default)({
    'sb-inline-message sb-inline-message-error': type === _constants.INLINE_MESSAGE_TYPE_ERROR,
    'sb-inline-message sb-inline-message-warning': type === _constants.INLINE_MESSAGE_TYPE_WARNING,
    'sb-inline-message sb-inline-message-info': type === _constants.INLINE_MESSAGE_TYPE_INFO,
    'sb-inline-message sb-inline-message-desc': type === _constants.INLINE_MESSAGE_TYPE_DESC
  }, className);
}; // eslint-disable-next-line no-underscore-dangle


var _SbInlineMessage = function _SbInlineMessage(props) {
  var id = props.id,
      type = props.type,
      title = props.title,
      titleParams = props.titleParams,
      message = props.message,
      messageParams = props.messageParams,
      className = props.className,
      icon = props.icon,
      _ = props.intl.formatMessage,
      rest = _objectWithoutProperties(props, ["id", "type", "title", "titleParams", "message", "messageParams", "className", "icon", "intl"]);

  var translatedMessage = (0, _locales.translateMessage)(_, message, messageParams);
  var translatedTitle = (0, _locales.translateMessage)(_, title, titleParams);

  var alert = /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
    className: "title"
  }, icon && /*#__PURE__*/_react.default.createElement(_sbInlineMessageIcon.SbInlineMessageIcon, {
    type: type
  }), /*#__PURE__*/_react.default.createElement("strong", null, translatedTitle)), /*#__PURE__*/_react.default.createElement("div", null, translatedMessage));

  if (!title) {
    alert = /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", null, icon && type !== _constants.INLINE_MESSAGE_TYPE_INFO && /*#__PURE__*/_react.default.createElement(_sbInlineMessageIcon.SbInlineMessageIcon, {
      type: type
    }), translatedMessage));
  }

  return /*#__PURE__*/_react.default.createElement("div", _extends({}, rest, {
    id: id,
    key: id,
    className: getClassNames(type, className)
  }), alert);
};

_SbInlineMessage.propTypes = {
  className: _propTypes.default.string,
  id: _propTypes.default.string,
  intl: _shapes.intlShape.isRequired,
  message: _propTypes.default.oneOfType([_propTypes.default.string, _shapes.PropTypeMessage, _propTypes.default.node]),
  title: _propTypes.default.oneOfType([_propTypes.default.string, _shapes.PropTypeMessage, _propTypes.default.node]),
  type: _propTypes.default.oneOf([_constants.INLINE_MESSAGE_TYPE_DESC, _constants.INLINE_MESSAGE_TYPE_ERROR, _constants.INLINE_MESSAGE_TYPE_INFO, _constants.INLINE_MESSAGE_TYPE_WARNING, '']),
  messageParams: _propTypes.default.object,
  // eslint-disable-line
  titleParams: _propTypes.default.object,
  // eslint-disable-line
  icon: _propTypes.default.bool
};
_SbInlineMessage.defaultProps = {
  className: '',
  id: '',
  message: '',
  title: '',
  type: '',
  messageParams: {},
  titleParams: {},
  icon: false
};
var SbInlineMessage = (0, _reactIntl.injectIntl)(_SbInlineMessage);
exports.SbInlineMessage = SbInlineMessage;
//# sourceMappingURL=sb-inline-message.js.map